// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"01a9549a","455":"87a6c4bc","977":"5a4442b5"}[chunkId] + ".chunk.js";
};